import React from 'react';
import GenAiReveal from './GenAiReveal';
import { GEN_AI_CREATIVE_LANDING } from '../../data/genAiCreativeLanding';

const GenAiBenefits = () => {
  const { benefits } = GEN_AI_CREATIVE_LANDING;

  return (
    <section className="bg-white px-5 py-16 md:px-10 md:py-20 xl:px-[100px] xl:py-[120px]">
      <div className="mx-auto max-w-[1240px]">
        <GenAiReveal>
          <h2 className="text-[32px] font-bold leading-none text-[#0b0b0b] md:text-4xl xl:text-[48px]">
            {benefits.title}
          </h2>
        </GenAiReveal>

        <div className="mt-10 grid gap-6 xl:grid-cols-3">
          {benefits.items.map((item, index) => (
            <GenAiReveal key={item.id} delay={index * 90}>
              <article className="flex h-full flex-col justify-between rounded-3xl bg-[#ecebf2] p-7 shadow-[0_12px_12px_rgba(29,22,29,0.04)]">
                <div>
                  <span className="inline-flex rounded-xl border border-[#2b7afe] bg-[rgba(43,122,254,0.07)] px-5 py-3 text-sm font-semibold text-[#2b7afe]">
                    {item.tag}
                  </span>
                  <h3 className="mt-5 text-xl font-bold leading-[1.1] text-[#0b0b0b] md:text-2xl">
                    {item.title}
                  </h3>
                  <p className="mt-4 text-base leading-[1.3] text-[#2f2f2f]/80">
                    {item.description}
                  </p>
                </div>
                <div className="gen-ai-benefit-media mt-8 overflow-hidden rounded-2xl">
                  <img
                    src={item.image}
                    alt=""
                    className="h-[200px] w-full object-cover object-center md:h-[220px]"
                  />
                </div>
              </article>
            </GenAiReveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GenAiBenefits;
